var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c("div", { attrs: { id: "Admin" } }, [
        _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("section-title", {
              staticStyle: { "font-size": "24px" },
              attrs: { title: "Overview", fontweight: "bold" }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("Shop Name: " + _vm._s(_vm.shop.shop_name))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Business Form: " +
                  _vm._s(
                    _vm.$t("business.form." + _vm.shop.info.business.form_id)
                  )
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Business Type: " +
                  _vm._s(
                    _vm.$t("business.type." + _vm.shop.info.business.type_id)
                  )
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("\n      Installed:\n      "),
                _vm._l(_vm.shop.install_apps, function(permission, index) {
                  return _c(
                    "span",
                    {
                      staticClass: "badge badge-secondary",
                      style:
                        "margin: 0 5px 0 0;background:" +
                        _vm.$t(
                          _vm.getAppInfo(permission.app_id).translate +
                            ".bgcolor"
                        )
                    },
                    [
                      _c("i", {
                        class: _vm.$t(
                          _vm.getAppInfo(permission.app_id).translate + ".icon"
                        )
                      }),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              _vm.getAppInfo(permission.app_id).translate +
                                ".title"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("p", [_vm._v("Products: " + _vm._s(_vm.shop.products.length))]),
            _vm._v(" "),
            _c("p", [
              _vm._v("POS Sessions: " + _vm._s(_vm.shop.pos_sessions.length))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "POS Transactions: " + _vm._s(_vm.shop.pos_transactions.length)
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("PO: " + _vm._s(_vm.shop.purchases.length))]),
            _vm._v(" "),
            _c("p", [_vm._v("SO: " + _vm._s(_vm.shop.sales.length))]),
            _vm._v(" "),
            _c("p", [_vm._v("INV: " + _vm._s(_vm.shop.invoices.length))]),
            _vm._v(" "),
            _c("p", [_vm._v("EXP: " + _vm._s(_vm.shop.expenses.length))]),
            _vm._v(" "),
            _c("p", [_vm._v("PE: " + _vm._s(_vm.shop.payments.length))]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Customers: " + _vm._s(_vm.shop.customers.length))
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Vendors: " + _vm._s(_vm.shop.vendors.length))]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Warehouses: " + _vm._s(_vm.shop.warehouses.length))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("section-title", {
              staticStyle: { "font-size": "24px" },
              attrs: {
                title: "Products " + _vm.shop.products.length,
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "dataTable table table-bordered",
                staticStyle: { width: "100%" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticStyle: { width: "50px" } }, [
                      _vm._v(_vm._s(_vm.$t("message.image")))
                    ]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.category")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.modifier")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.discount")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.tax")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.barcode")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.sku")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.item")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.price")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.cost")))])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.shop.products, function(item, index) {
                    return _c(
                      "tr",
                      {
                        staticStyle: {
                          width: "50px",
                          "vertical-align": "middle"
                        }
                      },
                      [
                        _c(
                          "td",
                          [
                            item.type == "product"
                              ? _c(
                                  "router-link",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      top: "-2px"
                                    },
                                    attrs: {
                                      to: {
                                        name: "ProductEdit",
                                        query: {
                                          pid: item.product_id,
                                          pname: item.product_name
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          item.images.thumbnail ||
                                          _vm.defaultImages.product,
                                        width: "68",
                                        height: "68"
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          item.category_name
                            ? _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [
                                  _c("i", {
                                    staticClass: "icon fas fa-sitemap"
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.category_name) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.modifiers, function(modifier, index) {
                            return _c(
                              "span",
                              {
                                key: modifier.modifier_id,
                                staticClass: "badge badge-secondary",
                                staticStyle: { "margin-right": "5px" }
                              },
                              [
                                _c("i", {
                                  staticClass: "icon fas fa-project-diagram"
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(modifier.modifier_name) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.discounts, function(discount, index) {
                            return _c(
                              "span",
                              {
                                key: discount.modifier_id,
                                staticClass: "badge badge-secondary",
                                staticStyle: { "margin-right": "5px" }
                              },
                              [
                                _c("i", { staticClass: "fas fa-tag" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(discount.discount_name) +
                                    "\n              "
                                ),
                                discount.type == "percentage"
                                  ? [
                                      _vm._v(
                                        "\n                (" +
                                          _vm._s(discount.amount) +
                                          "%)\n              "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                discount.type == "number"
                                  ? [
                                      _vm._v(
                                        "\n                (" +
                                          _vm._s(_vm.currency) +
                                          " " +
                                          _vm._s(discount.amount) +
                                          ")\n              "
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.taxes, function(tax, index) {
                            return _c(
                              "span",
                              {
                                key: tax.modifier_id,
                                staticClass: "badge badge-secondary",
                                staticStyle: { "margin-right": "5px" }
                              },
                              [
                                _c("i", { staticClass: "fas fa-dollar-sign" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(tax.tax_name) +
                                    "\n              (" +
                                    _vm._s(tax.amount) +
                                    "%)\n            "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.prices, function(price) {
                            return _c(
                              "div",
                              [
                                [
                                  price.barcode !== null
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "ProductEdit",
                                                  query: {
                                                    pid: item.product_id,
                                                    pname: item.product_name
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(price.barcode) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("span", [_vm._v("-")])
                                ]
                              ],
                              2
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.prices, function(price) {
                            return _c(
                              "div",
                              [
                                [
                                  price.sku_code !== null
                                    ? _c(
                                        "span",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "ProductEdit",
                                                  query: {
                                                    pid: item.product_id,
                                                    pname: item.product_name
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(price.sku_code) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : [
                                        _vm.isFoundCustomSkuCode(item.prices)
                                          ? _c("span", [_vm._v("-")])
                                          : _vm._e()
                                      ]
                                ]
                              ],
                              2
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.prices, function(price) {
                            return _c(
                              "div",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "ProductEdit",
                                        query: {
                                          pid: item.product_id,
                                          pname: item.product_name
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getProductFullName(
                                            item.product_name,
                                            price.attributes
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !price.is_available
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "badge badge-danger",
                                        staticStyle: {
                                          "font-size": "9px",
                                          position: "relative",
                                          top: "-1px"
                                        }
                                      },
                                      [_vm._v("ไม่มีจำหน่าย")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.prices, function(price) {
                            return _c(
                              "div",
                              [
                                price.price !== null
                                  ? [
                                      _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.getNumber(price.price)) +
                                            "\n                "
                                        )
                                      ])
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("message.variable")) +
                                          "\n              "
                                      )
                                    ]
                              ],
                              2
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(item.prices, function(price) {
                            return _c(
                              "div",
                              [
                                price.cost !== null
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.getNumber(price.cost)) +
                                          "\n              "
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          0
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("section-title", {
              staticStyle: { "font-size": "24px" },
              attrs: {
                title: "Warehouses " + _vm.shop.warehouses.length,
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "dataTable table table-bordered",
                staticStyle: { width: "100%" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.shop.warehouses, function(warehouse, index) {
                    return _c("tr", [
                      _c(
                        "td",
                        { class: [{ "text-primary": warehouse.primary }] },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(warehouse.warehouse_name) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(warehouse.short_name) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(warehouse.info.address) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getDateTime(warehouse.created_at)) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(warehouse.is_deleted) +
                            "\n          "
                        )
                      ])
                    ])
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("section-title", {
              staticStyle: { "font-size": "24px" },
              attrs: {
                title: "Stocks " + _vm.stocks.length,
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _vm._l(_vm.stocks, function(stock, index) {
              return _c(
                "table",
                {
                  staticClass: "dataTable table table-bordered",
                  staticStyle: { width: "100%" }
                },
                [
                  _vm._m(1, true),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(stock, function(item, index) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getProductFullName(
                                  item.product.product_name,
                                  item.sku.attributes
                                )
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.stock.control.minstock) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.stock.control.maxstock) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.stock.bin) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.stock.instock) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.stock.reserved) +
                              "\n          "
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("section-title", {
              staticStyle: { "font-size": "24px" },
              attrs: {
                title: "POS Transactions " + _vm.shop.pos_transactions.length,
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "dataTable table table-bordered",
                staticStyle: { width: "100%" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("message.date")))
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("message.time")))
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("apps.pos.message.ordernumbersort")))
                    ]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.productlist")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.customer")))]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(_vm.$t("message.cashier")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-right",
                        staticStyle: { "min-width": "100px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totaldiscount")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-right",
                        staticStyle: { "min-width": "100px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totaltax")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-right",
                        staticStyle: { "min-width": "100px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totalcollected")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-right",
                        staticStyle: { "min-width": "100px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totalrefund")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-right",
                        staticStyle: { "min-width": "100px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.nettotal")))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.shop.pos_transactions, function(bill, index) {
                    return _c(
                      "tr",
                      { attrs: { id: "ref-" + bill.posbi_code } },
                      [
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getDate(bill.created_at)) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getDateCustom(bill.created_at, {
                                  format: "H:mm"
                                })
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(bill.posbi_code) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [_c("item-list", { attrs: { orders: bill.orders } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            bill.customer
                              ? _c("router-link-custom", {
                                  attrs: {
                                    to: {
                                      name: "ContactCustomerEdit",
                                      query: {
                                        cus_id: bill.customer.customer_id,
                                        cus_name: bill.customer.customer_name
                                      }
                                    },
                                    text: bill.customer.customer_name,
                                    to_appid: 11,
                                    current_appid: 1,
                                    disabled: bill.customer.is_deleted == true
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(bill.user.email || bill.user.username) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getNumber(
                                  _vm.getBillTotalPrice(bill.orders, _vm.mixin)
                                    .discount
                                )
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getNumber(
                                  _vm.getBillTotalPrice(bill.orders, _vm.mixin)
                                    .tax
                                )
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getNumber(bill.total)) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getNumber(_vm.getTotalRefunds(bill.refunds))
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getNumber(
                                  bill.total - _vm.getTotalRefunds(bill.refunds)
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("section-title", {
              staticStyle: { "font-size": "24px" },
              attrs: {
                title: "Customers " + _vm.shop.customers.length,
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "dataTable table table-bordered",
                staticStyle: { width: "100%" }
              },
              [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.shop.customers, function(customer, index) {
                    return _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(customer.customer_name) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(customer.gender) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(customer.birthdate) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(customer.address) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getDateTime(customer.created_at)) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(customer.is_deleted) +
                            "\n          "
                        )
                      ])
                    ])
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("section-title", {
              staticStyle: { "font-size": "24px" },
              attrs: {
                title: "Vendors " + _vm.shop.vendors.length,
                fontweight: "bold"
              }
            }),
            _vm._v(" "),
            _c(
              "table",
              {
                staticClass: "dataTable table table-bordered",
                staticStyle: { width: "100%" }
              },
              [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.shop.vendors, function(vendor, index) {
                    return _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(vendor.vendor_name) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(vendor.gender) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(vendor.birthdate) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(vendor.address) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getDateTime(vendor.created_at)) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(vendor.is_deleted) +
                            "\n          "
                        )
                      ])
                    ])
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("hr")
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Warehouse Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Short Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Address")]),
        _vm._v(" "),
        _c("th", [_vm._v("Created")]),
        _vm._v(" "),
        _c("th", [_vm._v("is_deleted")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Product Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Min Stock")]),
        _vm._v(" "),
        _c("th", [_vm._v("Max Stock")]),
        _vm._v(" "),
        _c("th", [_vm._v("Bin Location")]),
        _vm._v(" "),
        _c("th", [_vm._v("In Stock")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reserved")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Customer Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Gender")]),
        _vm._v(" "),
        _c("th", [_vm._v("Birthdate")]),
        _vm._v(" "),
        _c("th", [_vm._v("address")]),
        _vm._v(" "),
        _c("th", [_vm._v("created")]),
        _vm._v(" "),
        _c("th", [_vm._v("is_deleted")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Customer Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Gender")]),
        _vm._v(" "),
        _c("th", [_vm._v("Birthdate")]),
        _vm._v(" "),
        _c("th", [_vm._v("address")]),
        _vm._v(" "),
        _c("th", [_vm._v("created")]),
        _vm._v(" "),
        _c("th", [_vm._v("is_deleted")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7e09898", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7e09898","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ShopInfo.vue
// module id = null
// module chunks = 